<div
  class="rounded-2xl bg-white p-1 2xsm:p-2 pt-4 shadow-theme-xs border border-gray-200">

  <!-- Header -->
  <div class="mb-6 flex items-center justify-between px-2 pt-2">
    <button
      (click)="prevMonth()"
      [disabled]="!canGoPrev()"
      class="flex h-10 w-10 items-center justify-center rounded-lg border border-gray-300 bg-white shadow-theme-md transition-all hover:bg-gray-50 disabled:opacity-20 disabled:cursor-not-allowed"
    >
      <lib-icon name="long-arrow-left" class="size-5 text-gray-700"></lib-icon>
    </button>
    <div class="text-center">
      <h3
        class="text-center font-title text-theme-sm font-medium text-gray-700"
      >
        {{ currentMonthName() }}
      </h3>
      <p
        class="mt-0.5 text-center font-title text-theme-xs font-normal text-gray-700"
      >
        {{ currentYear() }}
      </p>
    </div>

    <button
      (click)="nextMonth()"
      [disabled]="!canGoNext()"
      class="flex h-10 w-10 items-center justify-center rounded-lg border border-gray-300 bg-white shadow-theme-md transition-all hover:bg-gray-50 disabled:opacity-20 disabled:cursor-not-allowed"
    >
      <lib-icon name="long-arrow-right" class="size-5 text-gray-700"></lib-icon>
    </button>
  </div>

  <!-- grid calendari -->
  <div class="w-full overflow-hidden">
    <!-- dies -->
    <div class="flex flex-col cursor-pointer">
      @for (week of [0, 1, 2, 3, 4, 5]; track week) { 
      @if ((calendarDays() | slice : week * 7 : (week + 1) * 7).length > 0) {
      @let isLast = (week + 1) * 7 >= calendarDays().length;
      <!--? dies row -->
      <div class="grid grid-cols-7 border-l border-gray-50 bg-gray-50">
        @for ( day of calendarDays() | slice : week * 7 : (week + 1) * 7; track
        day.date ) {
        <div
          class="relative flex items-center justify-center py-2 transition-colors last:border-r-0"
          [ngClass]="{
                  'bg-white': !day.isCurrentMonth,
                  'bg-gray-50/50': day.isToday,
                  'bg-gray-100/80': day.isPast && day.isCurrentMonth
                }"
        >
          <div
            class="font-title text-xs leading-[18px]"
            [ngClass]="
                    day.isCurrentMonth
                      ? day.isToday
                        ? 'text-gray-500 font-bold'
                        : day.isPast
                          ? 'text-gray-400'
                          : 'text-gray-600'
                      : 'text-gray-300'
                  "
          >
            @if (day.isCurrentMonth) { {{ day.isToday ? "Hoy" : day.dayNumber }}
            }
          </div>
        </div>
        }
      </div>

      <!--? irrigation schedule row -->
      <div
        class="grid grid-cols-7 bg-white"
        [ngClass]="{
              'border-b border-gray-200': !isLast 
            }"
      >
        @for ( day of calendarDays() | slice : week * 7 : (week + 1) * 7; track
        day.date ) {
        <div
          class="relative flex h-14 items-center justify-center transition-colors"
          [ngClass]="{
                  'bg-white': !day.isCurrentMonth,
                  'bg-gray-50': day.isPast && day.isCurrentMonth
                }"
        >
          @if (day.isCurrentMonth) { @if (day.value !== "--:--" && day.value !== undefined && day.value !== '00:00') {
          <lib-schedule-badge
            [value]="day.value"
            [isPast]="day.isPast"
            [isCurrentMonth]="day.isCurrentMonth"
          />
          } @else {
          <span
            class="text-center font-title text-xs font-normal leading-[18px] text-gray-400"
          >
            --:--
          </span>
          } }
        </div>
        }
      </div>
      } }
    </div>
  </div>
</div>
